/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_OverviewInputs */

const en_admin_nav_overview = /** @type {(inputs: Admin_Nav_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const zh_admin_nav_overview = /** @type {(inputs: Admin_Nav_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概览`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Admin_Nav_OverviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_overview = /** @type {((inputs?: Admin_Nav_OverviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_OverviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_overview(inputs)
	return zh_admin_nav_overview(inputs)
});
export { admin_nav_overview as "admin.nav.overview" }